import { createAction } from '@reduxjs/toolkit';

export const setWillCall = createAction('[WillCall] setWillCall');
export const setLoadedWillCall = createAction('[WillCall] setLoadedWillCall');
export const unReserveSetWillCall = createAction('[WillCall] unReserveSetWillCall');
export const setIsJustActivated = createAction('[WillCall] setIsJustActivated');
export const resetWillCall = createAction('[WillCall] resetWillCall');
